import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import { Row, Col } from "react-bootstrap";
import MyVouchersPage from "./MyVouchers/my-vouchers-page";
import EmployeeVouchersPage from "./Employee/EmployeeVouchersPage";
import VoucherGroupSummary from "./VoucherGroups/VoucherGroupSummary";
import VoucherGroupDetails from "./VoucherGroups/VoucherGroupDetails";
import VoucherGroupEditForm from "./VoucherGroups/VoucherGroupEditForm";
import AddVoucherGroupForm from "./VoucherGroups/AddVoucherGroupForm";
import AddVoucherForm from "./Vouchers/AddVoucherForm";
import VoucherDetailPage from "./Vouchers/VoucherDetail";
import BulkIssueVouchers from "./VoucherGroups/BulkIssueVouchers";
import BulkOneTimeExpense from "./Expenses/BulkOneTimeExpense";
import FaqPage from "./Faq/Faq";

import TravelManagerEmployeeDetails from "./Manager/TravelManagerEmployeeDetails";
import TravelManagerDashboard from "./Manager/TravelManagerDashboard";


const TravelPages = (props) => {
  // Create a simplified profile object with only what we need
  const isImpersonation = !!props.profile.ghost && props.profile.isAdmin;
  
  const travelProfile = {
    // Use ghost values when in impersonation mode, otherwise use regular profile values
    dataEmployeeId: isImpersonation ? props.profile.ghostDataEmployeeId : props.profile.dataEmployeeId,
    isAdmin: isImpersonation ? props.profile.ghostIsAdmin : props.profile.isAdmin,
    isManager: isImpersonation ? props.profile.ghostIsManager : props.profile.isManager,
    isImpersonation: isImpersonation,
  };

  return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu 
          isAdmin={travelProfile.isAdmin} 
          isManager={travelProfile.isManager}
        />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
          <Switch>           
            <Route exact path="/travel/myvouchers" component={MyVouchersPage} />
            <Route exact path="/travel/employees" component={EmployeeVouchersPage} />
            <Route exact path="/travel/employees/:employeeId" component={EmployeeVouchersPage} />
            <Route exact path="/travel/vouchergroups/add" component={AddVoucherGroupForm} />
            <Route exact path="/travel/vouchergroups/:voucherGroupId/edit" component={VoucherGroupEditForm} />
            <Route exact path="/travel/vouchergroups/:voucherGroupId/vouchers/add" component={AddVoucherForm} />
            <Route exact path="/travel/vouchergroups/:voucherGroupId/vouchers/bulk-issue" component={BulkIssueVouchers} />
            <Route exact path="/travel/vouchergroups/:voucherGroupId/vouchers/:voucherId/edit" component={VoucherDetailPage} />
            <Route exact path="/travel/vouchergroups/:voucherGroupId" component={VoucherGroupDetails} />            
            <Route exact path="/travel/vouchergroups" component={VoucherGroupSummary} />
            <Route exact path="/travel/onetime-expense" component={BulkOneTimeExpense} />
            <Route exact path="/travel/faq" component={FaqPage} />            
            {/* Manager Routes */}
            <Route 
              exact 
              path="/travel/manager/dashboard" 
              render={() => <TravelManagerDashboard profile={travelProfile} />} 
            />
            <Route 
              path="/travel/manager/employee/:employeeId?" 
              render={() => <TravelManagerEmployeeDetails profile={travelProfile} />} 
            />
            <Route exact path="/travel" component={MyVouchersPage} />
          </Switch>
        </Row>
      </Col>
    </>
  ); 
};

const mapStateToProps = (state) => {
  return { profile: state.profile };
};

export default connect(mapStateToProps)(TravelPages);